module.exports = __webpack_public_path__ + "U-wHIkQ_AgupXdkBT/illo-couple-phone.svg";